import { Grid } from 'antd';
import classnames from 'classnames';
import "./style";
import { jsx as _jsx } from "react/jsx-runtime";
var DefaultHeader = function DefaultHeader(props) {
  var hiddenIglooIcon = props.hiddenIglooIcon;
  var useBreakpoint = Grid.useBreakpoint;
  var _useBreakpoint = useBreakpoint(),
    md = _useBreakpoint.md;
  if (hiddenIglooIcon) return null;
  return md ? /*#__PURE__*/_jsx("div", {
    className: classnames({
      'igloo-layout-header': true
    }),
    children: /*#__PURE__*/_jsx("div", {
      className: "header-content",
      children: /*#__PURE__*/_jsx("div", {
        className: "header-left",
        children: /*#__PURE__*/_jsx("div", {
          className: "igloo-logo"
        })
      })
    })
  }) : /*#__PURE__*/_jsx("div", {
    className: classnames({
      'igloo-layout-header': true
    }),
    children: /*#__PURE__*/_jsx("div", {
      className: "igloo-logo"
    })
  });
};
export default DefaultHeader;